import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router";

type BackButtonProps = {
  route?: string;
};

const BackButton: React.FC<BackButtonProps> = (props) => {
  const { courseId } = useParams<{
    courseId: string;
  }>();
  const navigate = useNavigate();
  const currentPath = window.location.pathname;
  const pathSegments = currentPath.split("/");
  const { t } = useTranslation(["header"]);

  const handleGoBack = () => {
    if (props.route) {
      navigate(props.route);
    } else {
      if (pathSegments[pathSegments.length - 1] === "evaluation") {
        navigate(`/course/${courseId}`);
      } else {
        navigate(-1);
      }
    }
  };

  return (
    <button
      onClick={handleGoBack}
      className="btn btn-sm btn-neutral text-neutral-content shadow-md"
      type="button"
    >
      {t("backButton")}
    </button>
  );
};

export default BackButton;
